import { render, staticRenderFns } from "./config-navbar.vue?vue&type=template&id=344d2fdc&scoped=true&"
import script from "./config-navbar.vue?vue&type=script&lang=js&"
export * from "./config-navbar.vue?vue&type=script&lang=js&"
import style0 from "./config-navbar.vue?vue&type=style&index=0&id=344d2fdc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344d2fdc",
  null
  
)

export default component.exports